import { ChatCircleText, Plus, Terminal, X } from "@phosphor-icons/react";

export default function CopilotHeader({ showSidebar, onToggleSidebar, onNewChat, onClose }) {
  return (
    <div className="border-b border-zinc-950 bg-zinc-950 text-white px-4 py-2 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <Terminal size={14} />
        <span className="font-mono text-[11px] tracking-[0.2em] uppercase">smarterp.copilot</span>
        <span className="w-1.5 h-1.5 bg-emerald-400 rounded-full pulse-dot" />
      </div>
      <div className="flex items-center gap-3">
        <button
          data-testid="copilot-sessions-toggle"
          onClick={onToggleSidebar}
          className={`hover:text-[#FF3E00] transition-colors ${showSidebar ? "text-[#FF3E00]" : ""}`}
          title="Toggle conversation history"
        >
          <ChatCircleText size={14} />
        </button>
        <button
          data-testid="copilot-new-chat-btn"
          onClick={onNewChat}
          className="hover:text-[#FF3E00] transition-colors"
          title="New chat"
        >
          <Plus size={14} />
        </button>
        <button data-testid="copilot-close-btn" onClick={onClose} className="hover:text-[#FF3E00] transition-colors">
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
